import {
  Button,
  Dropdown,
  Menu,
  Popconfirm,
} from "antd";
import Card from "components/card";
import * as appRoutes from "config/routes.config";
import React, { FC } from "react";

//!IMAGES
import { DownOutlined } from "@ant-design/icons";

//!STYLES
import { Link, useNavigate } from "react-router-dom";
import s from "./assets/card.module.css";

type Props = {
  room?: object | any;
  onArchiveClass: () => void;
  onDeleteClass: () => void;
  isLoading: boolean;
};

const OrganismCardClasses: FC<Props> = ({ room, onArchiveClass, onDeleteClass, isLoading }) => {

  const navigate = useNavigate();

  const handleSeeClass = () => {
    navigate(`${appRoutes.ORGANISM_CLASS_DETAILS}/${room?._id}`);
  }

  const menu = (
    <Menu>
      <Menu.Item key="see" onClick={handleSeeClass}>
        Voir la classe
      </Menu.Item>

      {room?.status === "PUBLISHED" && <Menu.Item key="archive">
        <Popconfirm
          title="Êtes-vous sûr de vouloir archiver cette classe ?"
          onConfirm={onArchiveClass}
          okText="Oui"
          cancelText="Non"
        >
          <span>Archiver la classe</span>
        </Popconfirm>
      </Menu.Item>}

      {room?.status === "PUBLISHED" && <Menu.Item key="delete">
        <Popconfirm
          title="Êtes-vous sûr de vouloir supprimer cette classe ?"
          onConfirm={onDeleteClass}
          okText="Oui"
          cancelText="Non"
        >
          <span style={{ color: "red" }}>Supprimer la classe</span>
        </Popconfirm>
      </Menu.Item>}
    </Menu>
  );

  return (
    <React.Fragment>
      <Link to={`${appRoutes.ORGANISM_CLASS_DETAILS}/${room?._id}`}>
        <Card className={s.card}>
          <div className={s.card__content}>
            <div style={{ position: "relative", top: "-30px", right: "-35%" }}></div>

            <div className={s.code}>
              <span>
                Code : {room?.accessCode?.split("-")[0].toUpperCase()}
              </span>
            </div>

            <div className={s.className}>
              <span title={room?.title || room?.name || ""}>
                {room?.title || room?.name || ""}
              </span>
            </div>

            <Dropdown overlay={menu} trigger={["click"]}>
              <Button className={s.dropdown} disabled={isLoading} loading={isLoading}>
                Actions <DownOutlined />
              </Button>
            </Dropdown>
          </div>
        </Card>
      </Link>
    </React.Fragment>
  );
};

export default OrganismCardClasses;